<!-- <pre>{{ dataObservable | async | json }}</pre> -->

<div class="wrapper">
  <div class="title">Asiakkaan työjono</div>

  <div style="margin-bottom: 20px">
    <mat-radio-group [formField]="lomake.historianMaara" name="amnt">
      <mat-radio-button value="50">50</mat-radio-button>
      <mat-radio-button value="100">100</mat-radio-button>
      <mat-radio-button value="500">500</mat-radio-button>
      <mat-radio-button value="1000">1000</mat-radio-button>
    </mat-radio-group>
  </div>

  @if (historiaObservable | async; as historiat) {
    @if (historiat.length > 0) {
      <table>
        <tr>
          @if (kirjanpitajaOnDevaajaObservable | async) {
            <td>Uri</td>
          }
          <td>From</td>
          <td>To</td>
          <td>Retries</td>
          <td>Next retry</td>
          <td>Viimeisin syy</td>
        </tr>
        @for (historia of historiat; track historia) {
          <tr style="border-bottom: 1px solid gray">
            @if (historia.uri) {
              <td><a [href]="historia.uri" target="_blank">Firestore</a></td>
            }
            <td>{{ historia.start | lokaalipvml: 'fi' }}</td>
            <td>{{ historia.end | lokaalipvml: 'fi' }}</td>
            <td>{{ historia.delayedTimes }}</td>
            <td>{{ historia.tryAgainEarliest | ltimestamptimel: 'fi' }}</td>
            <td>{{ historia.lastDelayReason }}</td>
          </tr>
        }
      </table>
    } @else {
      <div style="margin: 30px">Tietokannassa ei ole ajamattomia töitä.</div>
    }
  }
</div>
